import { Component, OnInit, Input } from '@angular/core';

@Component({
  selector: 'usb-item-transports',
  templateUrl: './item-transports.component.html',
  styleUrls: ['./item-transports.component.scss']
})
export class ItemTransportsComponent implements OnInit {

  @Input() item: any;
  @Input() styleSidebar: any;
  @Input() currencyAgency: any;
  @Input() currencies: any;
  arrivalDate: Date;
  departureDate: Date;
  _type:any;
  constructor() { }

  ngOnInit() {
    console.log('item', this.item);

  }
  // Pasar primer letra de cada palabra a mayuscula en una cadena
  stringUpperCase(str){
   // let e = str.toLowerCase()
    // return e.replace(/\b\w/g, l => l.toUpperCase())
    return str;
  }

      extractNameTransport(form: any, type: string): string {

      switch(type) {
        case 'origin':
          const formTransportOrigin = form?.formTransport?.firstOrigin;
          switch(form.payload[0]?.transfers?.pickupLocation?.type) {
            case 'hotel':
              return `${formTransportOrigin?.name || formTransportOrigin?.hotel_name} (${formTransportOrigin?.iata})`;
            case 'airport':
              return `${formTransportOrigin?.name} (${formTransportOrigin?.iata})`;
            case 'destination':
              return `${formTransportOrigin?.city_name} (${formTransportOrigin?.country_code})`;
          }
        case 'destination':
          const formTransportDestination = form?.formTransport?.firstDestination;
          switch(form.payload[0]?.transfers?.dropoffLocation?.type) {
            case 'hotel':
              return `${formTransportDestination?.name  || formTransportDestination?.hotel_name} (${formTransportDestination?.iata})`;
            case 'airport':
              return `${formTransportDestination?.name} (${formTransportDestination?.iata})`;
            case 'destination':
              return `${formTransportDestination?.city_name} (${formTransportDestination?.country_code})`;
          }
      }
    }

      extractAddressType(form: any, type: string, itemPayload: any): string {
      switch(type) {
        case 'origin':
          switch(itemPayload.transfers.pickupLocation.type) {
            case 'hotel':
              return `${itemPayload.transfers.pickupLocation.address}, ${form.city_name} (${form.country_code})`;
            case 'airport':
              return '';
            case 'destination':
              return `, ${form.city_province} (${form.country_code})`;
          }
        case 'destination':
          switch(itemPayload.transfers.dropoffLocation.type) {
            case 'hotel':
              return `${itemPayload.transfers.dropoffLocation.address}, ${form.city_name} (${form.country_code})`;
            case 'airport':
              return '';
            case 'destination':
              return `, ${form.city_province} (${form.country_code})`;
          }
      }
    }

    getMessageFirstTime(input: string, pickup: any): string {

      let firstOrigin = {};

      firstOrigin = input === 'origin' ? pickup : {};

      let message: string = '';
      const messageFly = 'Hora arribo del vuelo';
      const messageDestination = 'Hora pickup del hotel';

      if(firstOrigin && firstOrigin['type']) {
        message = firstOrigin['type'] === 'airport' ? messageFly : messageDestination;
      }


      return message

      }

        getBagsHands(bagsCapacity): number {
    return Number(bagsCapacity?.numberMediumSuitcases) + Number(bagsCapacity?.numberHandbags);
  }


}
